import { render, staticRenderFns } from "./data-authority.vue?vue&type=template&id=0fc36922&scoped=true&"
import script from "./data-authority.vue?vue&type=script&lang=js&"
export * from "./data-authority.vue?vue&type=script&lang=js&"
import style0 from "./data-authority.vue?vue&type=style&index=0&id=0fc36922&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc36922",
  null
  
)

export default component.exports